import { render } from "./EditPlan.vue?vue&type=template&id=bc80379a&scoped=true"
import script from "./EditPlan.vue?vue&type=script&lang=js"
export * from "./EditPlan.vue?vue&type=script&lang=js"

import "./EditPlan.vue?vue&type=style&index=0&id=bc80379a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc80379a"]])

export default __exports__